var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "角色编号" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["roleNo", _vm.rules.roleNo],
                            expression: "['roleNo', rules.roleNo]",
                          },
                        ],
                        attrs: { disabled: _vm.editStatus },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "角色名称" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["roleName", _vm.rules.roleName],
                            expression: "['roleName', rules.roleName]",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "角色类型" } },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["roleType", _vm.rules.roleType],
                            expression: "['roleType',rules.roleType]",
                          },
                        ],
                        attrs: { options: _vm.ruleTypeOptions },
                        on: { change: _vm.handleChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isDeptShow
                ? _c(
                    "a-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "所属部门" } },
                        [
                          _c("a-tree-select", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["belongDeptId", _vm.rules.belongDeptId],
                                expression:
                                  "['belongDeptId',rules.belongDeptId]",
                              },
                            ],
                            attrs: {
                              "allow-clear": "",
                              "show-search": "",
                              "dropdown-style": {
                                maxHeight: "300px",
                                overflow: "auto",
                              },
                              treeData: _vm.deptList,
                              treeDefaultExpandAll: false,
                              treeDefaultExpandedKeys: _vm.defaultExpandedKeys,
                              filterTreeNode: _vm.filterTreeNodeOption,
                              replaceFields: {
                                children: "children",
                                title: "deptName",
                                key: "deptId",
                                value: "deptId",
                              },
                            },
                            on: {
                              "update:treeDefaultExpandedKeys": function (
                                $event
                              ) {
                                _vm.defaultExpandedKeys = $event
                              },
                              "update:tree-default-expanded-keys": function (
                                $event
                              ) {
                                _vm.defaultExpandedKeys = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "是否使用" } },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["isUse", { valuePropName: "checked" }],
                            expression:
                              "['isUse',{ valuePropName: 'checked' }]",
                          },
                        ],
                        attrs: {
                          "checked-children": "是",
                          "un-checked-children": "否",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "是否系统角色" } },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["isSystem", { valuePropName: "checked" }],
                            expression:
                              "['isSystem',{ valuePropName: 'checked' }]",
                          },
                        ],
                        attrs: {
                          disabled: true,
                          "checked-children": "是",
                          "un-checked-children": "否",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "是否可见手机号" } },
                    [
                      _c("a-switch", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "isShowMobile",
                              { valuePropName: "checked" },
                            ],
                            expression:
                              "['isShowMobile',{ valuePropName: 'checked' }]",
                          },
                        ],
                        attrs: {
                          "checked-children": "是",
                          "un-checked-children": "否",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "备注",
                    "label-col": { span: 4 },
                    "wrapper-col": { span: 20 },
                  },
                },
                [
                  _c("a-textarea", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["remark"],
                        expression: "['remark']",
                      },
                    ],
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              staticClass: "tabsClass",
              model: {
                value: _vm.activeKey,
                callback: function ($$v) {
                  _vm.activeKey = $$v
                },
                expression: "activeKey",
              },
            },
            _vm._l(_vm.menuList, function (item, index) {
              return _c(
                "el-tab-pane",
                { key: index, attrs: { label: item.name } },
                [
                  _c("menuChildTable", {
                    ref: "menuChildTable" + index,
                    refInFor: true,
                    attrs: { listArr: item.children, "row-id": _vm.rowId },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "a-row",
            { staticStyle: { "margin-top": "30px" } },
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "数据权限",
                        "label-col": { span: 2 },
                        "wrapper-col": { span: 22 },
                      },
                    },
                    [
                      _c("a-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["adminType", _vm.rules.adminType],
                            expression: "['adminType',rules.adminType]",
                          },
                        ],
                        attrs: { options: _vm.adminTypeOptions },
                        on: { change: _vm.handleChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.adminType === 3
            ? _c(
                "a-tabs",
                [
                  _c(
                    "a-tab-pane",
                    { key: "1", attrs: { tab: "管理部门", forceRender: true } },
                    [
                      _c("a-tree", {
                        attrs: {
                          checkable: true,
                          selectable: false,
                          autoExpandParent: true,
                          "expanded-keys": _vm.expandedKeys,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                            value: "deptId",
                          },
                          "tree-data": _vm.deptList,
                        },
                        on: { expand: _vm.onExpand },
                        model: {
                          value: _vm.checkedKeys,
                          callback: function ($$v) {
                            _vm.checkedKeys = $$v
                          },
                          expression: "checkedKeys",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }